import { useClerkComponentTracking } from "@/hooks/useClerkComponentTracking";
import { SignIn } from "@clerk/clerk-react";
import { useEffect } from "react";
import { captureEvent } from "@/utils/posthog";
import { useIsMobileWeb } from "@/hooks/useIsMobileWeb";
import DownloadAppCta from "@/components/mobile/DownloadAppCta";
import { AuthLayout, clerkAuthAppearance } from "./AuthLayout";

export function SignInPage() {
  const currentUrl = window.location.origin;
  const fromSignUp =
    new URLSearchParams(window.location.search).get("fromSignUp") === "true";
  const redirectLinkSignIn = `${currentUrl}/?afterSignIn=true${
    fromSignUp ? "&fromSignUp=true" : ""
  }`;
  const isMobileWeb = useIsMobileWeb();

  useClerkComponentTracking("sign_in");

  useEffect(() => {
    captureEvent("sign_in_view");
  }, []);

  return (
    <AuthLayout isMobileWeb={isMobileWeb}>
      <SignIn
        appearance={clerkAuthAppearance}
        routing="virtual"
        forceRedirectUrl={redirectLinkSignIn}
        fallbackRedirectUrl={redirectLinkSignIn}
        signUpUrl="/sign-up"
        // See SignUp.tsx: popups are silently blocked by in-app browsers.
        oauthFlow="redirect"
      />
      {isMobileWeb && <DownloadAppCta />}
    </AuthLayout>
  );
}
